import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "prefixCls", "type", "size", "hideAdd", "onEdit", "getPopupContainer", "tabListBorder", "operationNodeDropdownProps"];
import * as React from 'react';
import classNames from 'classnames';
import RcTabs, { TabPane } from '@bedrock/tabs';
import Close from '@bedrock/icons-react/Close';
import Plus from '@bedrock/icons-react/Plus';
import Ellipsis from '@bedrock/icons-react/Ellipsis';
import { ConfigContext, SizeContext, getModifyName } from '../ConfigProvider';
import isTouchDevice from '../utils/isTouchDevice';

var Tabs = function Tabs(props) {
  var _classNames;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      getContextPopupContainer = _React$useContext.getPopupContainer;

  var contextSize = React.useContext(SizeContext);

  var className = props.className,
      propPrefixCls = props.prefixCls,
      type = props.type,
      propSize = props.size,
      hideAdd = props.hideAdd,
      _onEdit = props.onEdit,
      getPopupContainer = props.getPopupContainer,
      tabListBorder = props.tabListBorder,
      propOperationNodeDropdownProps = props.operationNodeDropdownProps,
      restProps = _objectWithoutProperties(props, _excluded);

  var prefixCls = getPrefixCls('tabs', propPrefixCls);
  var size = propSize || contextSize || 'medium';

  var operationNodeDropdownProps = _objectSpread({
    trigger: [isTouchDevice() ? 'click' : 'hover']
  }, propOperationNodeDropdownProps);

  var editable;

  if (type === 'editable-card') {
    editable = {
      onEdit: function onEdit(editType, _ref) {
        var key = _ref.key,
            event = _ref.event;
        _onEdit && _onEdit(editType === 'add' ? event : key, editType);
      },
      removeIcon: /*#__PURE__*/React.createElement(Close, {
        size: 16
      }),
      addIcon: /*#__PURE__*/React.createElement(Plus, {
        size: 16
      }),
      showAdd: hideAdd !== true
    };
  }

  return /*#__PURE__*/React.createElement(RcTabs, _objectSpread(_objectSpread({
    moreIcon: /*#__PURE__*/React.createElement(Ellipsis, {
      size: 16
    }),
    moreTransitionName: "slide-up"
  }, restProps), {}, {
    className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(getModifyName(size)), size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), ['card', 'editable-card'].includes(type)), _defineProperty(_classNames, "".concat(prefixCls, "-round"), type === 'round'), _defineProperty(_classNames, "".concat(prefixCls, "-text"), type === 'text'), _defineProperty(_classNames, "".concat(prefixCls, "-editable-card"), type === 'editable-card'), _defineProperty(_classNames, "".concat(prefixCls, "-button"), type === 'button'), _defineProperty(_classNames, "".concat(prefixCls, "-button-primary"), type === 'button-primary'), _defineProperty(_classNames, "".concat(prefixCls, "-button-round"), type === 'button-round'), _defineProperty(_classNames, "".concat(prefixCls, "-nav-list-borderless"), tabListBorder === false), _classNames), className),
    editable: editable,
    prefixCls: prefixCls,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    operationNodeDropdownProps: operationNodeDropdownProps
  }));
};

Tabs.defaultProps = {
  showInkBar: true,
  tabListBorder: true
};
export default Tabs;
export { TabPane };